class SessionManager {
  constructor() {
    this.loggedIn = false;
    this.csrfToken = "";
  }

  logIn() {
    this.loggedIn  = true;
  }

  isLoggedIn() {
    return !!this.loggedIn;
  }

  setCSRFToken(csrfToken) {
    this.csrfToken = csrfToken;
  }

  getCSRFToken() {
    return this.csrfToken;
  }
}

export default SessionManager;



// WEBPACK FOOTER //
// ./app/javascript/helpers/SessionManager.js